<!--
 * @Author: xuliqi
 * @Date: 2020-11-06 15:00:01
 * @Description: 
-->
<template>
  <div class="doctor_management">
    <Tabs type="card" :animated="false" name="tab1" class="tab1">
      <TabPane label="中心医生列表" tab="tab1">
        <Divider />
        <div class="opration">
          <div class="search">
            <span>医生姓名：</span>
            <Input
              v-model="doctorName"
              placeholder="请输入"
              style="width: 200px"
            />
            <Button
              style="margin-left: 15px"
              type="primary"
              @click="getDoctorList(1, true)"
              >查询</Button
            >
          </div>
          <Button type="primary" ghost icon="md-add" @click="addDoctor"
            >新建</Button
          >
        </div>
        <Table :columns="columns1" :data="data1"></Table>
        <div class="pagination">
          <Page
            :current="pageNum"
            :page-size-opts="pageSizeOpts"
            :total="doctor_total"
            :page-size="pageSize"
            show-elevator
            show-total
            show-sizer
            @on-change="getDoctorList"
          />
        </div>
      </TabPane>
      <TabPane label="基层医生申请列表" tab="tab1">
        <Divider />
        <div class="opration">
          <div class="search">
            <span>医生姓名：</span>
            <Input
              v-model="doctorName1"
              placeholder="请输入"
              style="width: 200px"
            />
            <Button
              @click="getDoctorList1(1, true)"
              style="margin-left: 15px"
              type="primary"
              >查询</Button
            >
          </div>
        </div>
        <Table :columns="columns2" :data="data2"></Table>
        <div class="pagination">
          <Page
            :current="pageNum1"
            :page-size-opts="pageSizeOpts"
            :total="doctor_total1"
            :page-size="pageSize1"
            show-elevator
            show-total
            show-sizer
            @on-change="getDoctorList1"
          />
        </div>
      </TabPane>
    </Tabs>
    <Modal
      v-model="returnModal"
      footer-hide
      width="350"
      class-name="return_modal"
    >
      <span class="title">退回原因</span>
      <div class="content">
        <Input type="textarea" :rows="5" v-model="returnResult"></Input>
      </div>
      <div class="btn_box">
        <Button
          size="small"
          @click="
            () => {
              this.returnModal = false;
            }
          "
          >取消</Button
        >
        <Button type="primary" size="small" @click="returnIsok">确定</Button>
      </div>
    </Modal>
    <Modal v-model="editModal" footer-hide width="800" class-name="modal1">
      <span class="title">{{ modalTitle }}</span>
      <div class="content">
        <Row>
          <Col span="8">
            <div class="mod">
              <div class="label_title">
                医生姓名<span class="color_red">*</span>
              </div>
              <Input
                :disabled="
                  modalTitle == '审核基层医生' || modalTitle == '查看基层医生'
                "
                v-model="formItem.name"
                placeholder="请填写医生姓名"
              ></Input>
            </div>
          </Col>
          <Col span="8">
            <div class="mod">
              <div class="label_title">医生年龄</div>
              <Input
                :disabled="
                  modalTitle == '审核基层医生' || modalTitle == '查看基层医生'
                "
                v-model="formItem.age"
                placeholder="请填写医生年龄"
                type="number"
              ></Input>
            </div>
          </Col>
          <Col span="8">
            <div class="mod">
              <div class="label_title">医生性别</div>
              <Select
                :disabled="
                  modalTitle == '审核基层医生' || modalTitle == '查看基层医生'
                "
                v-model="formItem.sex"
                style="width: 200px"
              >
                <Option value="男">男</Option>
                <Option value="女">女</Option>
              </Select>
            </div>
          </Col>
          <Col span="8">
            <div class="mod">
              <div class="label_title">
                手机号码<span class="color_red">*</span>
              </div>
              <Input
                v-model="formItem.phone"
                :disabled="modalTitle.includes('新增') ? false : true"
                placeholder="请填写医生手机号码"
                type="tel"
              ></Input>
            </div>
          </Col>
          <Col span="8">
            <div class="mod">
              <div class="label_title">
                所属医院<span class="color_red">*</span>
              </div>
              <Select
                :disabled="
                  modalTitle == '审核基层医生' || modalTitle == '查看基层医生'
                "
                v-model="formItem.hospital"
                style="width: 200px"
                :filterable="remoteFlag"
                :remote-method="searchHospital"
                :loading="searchHospitalLoading"
                placeholder="请输入关键字进行查询"
                @on-change="hospitalListChange"
              >
                <Option
                  v-for="(item, index) in hospitalList"
                  :key="index"
                  :value="item.OrgName"
                  >{{ item.OrgName }}</Option
                >
              </Select>
            </div>
          </Col>
          <Col span="8">
            <div class="mod">
              <div class="label_title">
                所属科室<span class="color_red">*</span>
              </div>
              <Select
                :disabled="
                  modalTitle == '审核基层医生' || modalTitle == '查看基层医生'
                "
                v-model="formItem.department"
                style="width: 200px"
              >
                <Option
                  v-for="(item, index) in departmentList"
                  :key="index"
                  :value="item.DepartmentName"
                  >{{ item.DepartmentName }}</Option
                >
              </Select>
            </div>
          </Col>
          <Col span="8">
            <div class="mod">
              <div class="label_title">
                角色<span class="color_red">*</span>
              </div>
              <Select
                :disabled="
                  modalTitle == '审核基层医生' || modalTitle == '查看基层医生'
                "
                v-model="formItem.role"
                style="width: 200px"
              >
                <Option
                  value="中心管理员"
                  v-if="modalTitle.includes('中心医生')"
                  >中心管理员</Option
                >
                <Option value="医生">医生</Option>
              </Select>
            </div>
          </Col>
          <Col span="8">
            <div class="mod">
              <div class="label_title">
                职称<span class="color_red">*</span>
              </div>
              <Select
                :disabled="
                  modalTitle == '审核基层医生' || modalTitle == '查看基层医生'
                "
                @on-change="titleChange"
                v-model="formItem.title"
                style="width: 200px"
              >
                <Option value="住院医师">住院医师</Option>
                <Option value="主治医师">主治医师</Option>
                <Option value="副主任医师">副主任医师</Option>
                <Option value="主任医师">主任医师</Option>
              </Select>
            </div>
          </Col>
          <Col span="8">
            <div class="mod">
              <div class="label_title">擅长</div>
              <Input
                :disabled="
                  modalTitle == '审核基层医生' || modalTitle == '查看基层医生'
                "
                v-model="formItem.skill"
                style="width: 200px"
                placeholder="请输入内容"
                type="textarea"
                :rows="1"
              />
            </div>
          </Col>
          <Col span="8">
            <div class="mod">
              <div class="label_title">简介</div>
              <Input
                :disabled="
                  modalTitle == '审核基层医生' || modalTitle == '查看基层医生'
                "
                v-model="formItem.intro"
                placeholder="请填写简介"
                type="textarea"
                :rows="1"
              ></Input>
            </div>
          </Col>
          <Col
            span="8"
            :style="modalTitle.includes('新增') ? '' : 'display:none'"
          >
            <div class="mod">
              <div class="label_title">
                密码<span class="color_red">*</span>
              </div>
              <Input
                v-model="formItem.password"
                placeholder="请填写密码"
                type="password"
                password
              ></Input>
            </div>
          </Col>
          <Col
            span="8"
            :style="modalTitle.includes('新增') ? '' : 'display:none'"
          >
            <div class="mod">
              <div class="label_title">
                确认密码<span class="color_red">*</span>
              </div>
              <Input
                v-model="formItem.rePassword"
                placeholder="请填写密码"
                type="password"
                password
              ></Input>
            </div>
          </Col>
          <Col span="8" :style="modalTitle.includes('中心医生') ? '' : 'display:none'">
          <div class="mod">
            <div class="label_title">
              分级<span class="color_red">*</span>
            </div>
            <Select :disabled="
                  modalTitle == '审核基层医生' || modalTitle == '查看基层医生'
                " v-model="formItem.level" style="width: 200px">
              <Option value="A">A</Option>
              <Option value="B">B</Option>
            </Select>
          </div>
          </Col>
          <Col
            span="16"
            :style="modalTitle == '查看基层医生' ? '' : 'display:none'"
          >
            <div class="mod" style="width: 90%">
              <div class="label_title">退回原因</div>
              <Input
                v-model="formItem.returnReason"
                type="textarea"
                disabled
              ></Input>
            </div>
          </Col>
        </Row>
        <div class="btn_box">
          <Button
            v-if="
              modalTitle == '编辑中心医生' ||
              modalTitle.includes('新增') ||
              modalTitle == '编辑基层医生'
            "
            type="primary"
            size="large"
            style="padding: 0 50px"
            @click="updateOrAddDoctorInfo"
            :loading="saveLoading"
            >保存</Button
          >
          <span class="basic_btn" v-else-if="modalTitle == '审核基层医生'">
            <Button
              type="primary"
              ghost
              size="large"
              style="padding: 0 50px"
              @click="pass"
              >通过</Button
            >
            <Button
              type="primary"
              ghost
              size="large"
              style="padding: 0 50px"
              @click="noPass"
              >不通过</Button
            >
          </span>
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import {
  Tabs,
  TabPane,
  Button,
  Input,
  Table,
  Page,
  Modal,
  Form,
  FormItem,
  Row,
  Col,
  Select,
  Option,
  Checkbox,
  Divider,
} from "view-design";
import Request from "../utils/request";
import config from "../config";
import Tools from "../utils/tools";
export default {
  components: {
    Tabs,
    TabPane,
    Button,
    Input,
    Table,
    Page,
    Modal,
    Form,
    FormItem,
    Row,
    Col,
    Select,
    Option,
    Checkbox,
    Divider,
  },
  data() {
    return {
      CenterID: JSON.parse(localStorage.getItem("Role")).CenterID,
      CenterName: JSON.parse(localStorage.getItem("Role")).CenterName,
      RoleID: JSON.parse(localStorage.getItem("Role")).RoleID,
      UserJid: JSON.parse(localStorage.getItem("Role")).UserJid,
      doctorNum: {
        pending: 0, //待审核
        passed: 0, //已通过
        fail: 0, //未通过
      }, //基层医生各个状态数量
      remoteFlag: true, //是否开启远程搜索
      saveLoading: false, //模态框中的保存按钮是否是加载中状态
      departmentList: [], //科室列表
      searchHospitalLoading: false, //医院是否正在查询中
      hospitalList: [], //医院列表
      returnResult: "", //退回原因
      returnModal: false, //退回模态框
      tab2Name: "tab2_1",
      pageSizeOpts: [10, 20, 30, 40, 50],
      /* 医生列表相关数据 */
      pageNum: 1, //当前显示的页码
      pageSize: 10, //每页显示的条数
      doctor_total: 0, //医生总数
      doctorRowInfo: "", //医生列表每一行的信息
      doctorName: "", //查询时医生的名字
      formItem: {
        name: "",
        age: "",
        sex: "",
        phone: "",
        department: "",
        role: "",
        title: "",
        skill: "",
        intro: "",
        password: "",
        rePassword: "",
        hospital: "",
        returnReason: "",
        level:''
      },
      columns1: [
        {
          title: "医生姓名",
          key: "DocName",
          align: "center",
          width: 130,
        },
        {
          title: "性别",
          key: "Sex",
          align: "center",
          width: 100,
        },
        {
          title: "年龄",
          key: "Age",
          align: "center",
          width: 100,
        },
        {
          title: "手机号码",
          key: "Cellphone",
          align: "center",
          width: 150,
        },
        {
          title: "所属医院",
          key: "HospitalName",
          align: "center",
        },
        {
          title: "所属科室",
          key: "DepartmentName",
          align: "center",
        },
        {
          title: "角色",
          key: "Role",
          align: "center",
          width: 120,
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          render: (h, params) => {
            return h("div", [
              h(
                "span",
                {
                  style: {
                    color: "#1890FF",
                    marginRight: "30px",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      console.log(params.row);
                      this.editModal = true;
                      this.modalTitle = "编辑中心医生";
                      this.doctorRowInfo = params;
                      this.formItem.name = params.row.DocName;
                      this.formItem.age = params.row.Age;
                      this.formItem.sex = params.row.Sex;
                      this.formItem.phone = params.row.Cellphone;
                      this.formItem.role = params.row.Role;
                      this.formItem.title = params.row.DocPosition || "";
                      this.formItem.skill = params.row.Skill;
                      this.formItem.intro = params.row.Introduce;
                      this.formItem.id = params.row.ID;
                      this.formItem.level = params.row.Level;
                      this.remoteFlag = false;
                      Request.postRequest(
                        config.SXG_baseUrl +
                          "/api/docmanager/GetAllHospitalsByFilter",
                        {
                          sFilter: params.row.HospitalName,
                        }
                      ).then((res) => {
                        // console.log(res)
                        if (res.code == 200) {
                          this.hospitalList = res.data;
                          this.formItem.hospital = params.row.HospitalName;
                          Request.postRequest(
                            config.SXG_baseUrl +
                              "/api/docmanager/GetDepartmentsByFilter",
                            {
                              sFilter: params.row.HealthOrgID,
                            }
                          ).then((res) => {
                            // console.log(res)
                            if (res.code == 200) {
                              this.departmentList = res.data;
                              this.formItem.department =
                                params.row.DepartmentName;
                              this.remoteFlag = true;
                            } else {
                              this.$Message.error(res.message);
                            }
                          });
                        } else {
                          this.$Message.error(res.message);
                        }
                      });
                    },
                  },
                },
                "编辑"
              ),
              h(
                "span",
                {
                  style: {
                    color: "#1890FF",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                          title: '确定要删除吗？',
                          onOk: this.ok
                      });
                      this.modalTitle = "编辑中心医生";
                      this.doctorRowInfo = params;
                    },
                  },
                },
                "删除"
              ),
            ]);
          },
        },
      ],
      data1: [],
      editModal: false,
      modalTitle: "新建中心医生",
      /* 基层医生相关数据*/
      doctorName1: "",
      doctorName1Value: "",
      doctor_total1: 0, //基层医生的总条数
      pageNum1: 1, //基层医生当前页
      pageSize1: 10, //基层医生每页数据的条数
      columns2: [
        {
          title: "医生姓名",
          key: "DocName",
          align: "center",
          width: 130,
        },
        {
          title: "性别",
          key: "Sex",
          align: "center",
          width: 100,
        },
        {
          title: "年龄",
          key: "Age",
          align: "center",
          width: 100,
        },
        {
          title: "手机号码",
          key: "Cellphone",
          align: "center",
          width: 150,
        },
        {
          title: "所属医院",
          key: "HospitalName",
          align: "center",
        },
        {
          title: "所属科室",
          key: "DepartmentName",
          align: "center",
        },
        {
          title: "状态",
          key: "IsJoinText",
          align: "center",
          width: 120,
        },
        {
          title: "操作",
          key: "operation",
          align: "center",
          render: (h, params) => {
            return h("div", [
              params.row.IsJoin == 'F' ? h(
                "span",
                {
                  style: {
                    color: "#1890FF",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                          title: '确定执行操作吗？',
                          onOk: ()=>{
                            Request.postRequest(config.SXG_baseUrl + '/api/docmanager/SaveDocCenter',{
                              tablename:'DocCenter',
                              ID:params.row.ID,
                              IsJoin:'T'
                            }).then(res=>{
                              if(res.code == 200){
                                this.getDoctorList1(this.pageNum);
                                Request.postRequest(config.SXG_baseUrl + '/api/casemanager/SendSMSMessage',{
                                  Cellphone:params.row.Cellphone,
                                  CenterName:params.row.CenterName,
                                  DocName:params.row.DocName
                                })
                                Request.addLog('医生管理','同意准入')
                              }else{
                                this.$Message.error(res.message)
                                Request.addLog('医生管理','同意准入','F',res.message)
                              }
                            })
                            // if (this.data2.length == 1 && this.doctor_total1 != 1) {
                            //   this.getDoctorList1(this.pageNum - 1);
                            // } else {
                            //   this.getDoctorList1(this.pageNum);
                            // }
                          }
                      });
                    },
                  },
                },
                "同意加入"
              ) : '',
              params.row.IsJoin == 'T' ? h(
                "span",
                {
                  style: {
                    color: "#FF4F66",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$Modal.confirm({
                          title: '确定执行操作吗？',
                          onOk: ()=>{
                            Request.postRequest(config.SXG_baseUrl + '/api/docmanager/SaveDocCenter',{
                              tablename:'DocCenter',
                              ID:params.row.ID,
                              IsJoin:'F'
                            }).then(res=>{
                              if(res.code == 200){
                                this.getDoctorList1(this.pageNum);
                              }else{
                                this.$Message.error(res.message)
                              }
                            })
                          }
                      });
                    },
                  },
                },
                "取消加入"
              ) : '',
            ]);
          },
        },
      ],
      data2: [],
    };
  },
  created() {
    this.getDoctorList(1);
    this.getDoctorList1(1);
    this.$emit("funChangeTitle", "医生管理", "3-1");
  },
  methods: {
    //职称改变时触发
    titleChange(v){
      if(this.modalTitle.includes('中心医生')){
        if(v == "住院医师" || v == "主治医师"){
          this.formItem.level = 'B'
        }else if(v == "副主任医师" || v == "主任医师"){
          this.formItem.level = 'A'
        }
      }
    },
    //查询医院列表
    searchHospital(val, event) {
      if (this.remoteFlag) {
        this.searchHospitalLoading = true;
        Request.postRequest(
          config.SXG_baseUrl + "/api/docmanager/GetAllHospitalsByFilter",
          {
            sFilter: val,
          }
        ).then((res) => {
          // console.log(res)
          if (res.code == 200) {
            this.hospitalList = res.data;
            this.searchHospitalLoading = false;
          } else {
            this.$Message.error(res.message);
            this.searchHospitalLoading = false;
          }
        });
      }
    },
    //获取科室列表
    hospitalListChange(val) {
      if (val) {
        let HealthOrgID = "";
        this.hospitalList.map((item) => {
          if (item.OrgName == val) {
            HealthOrgID = item.ID;
          }
        });
        Request.postRequest(
          config.SXG_baseUrl + "/api/docmanager/GetDepartmentsByFilter",
          {
            sFilter: HealthOrgID,
          }
        ).then((res) => {
          // console.log(res)
          if (res.code == 200) {
            this.formItem.department = "";
            this.departmentList = res.data;
          } else {
            this.$Message.error(res.message);
          }
        });
      }
    },

    /* ========================================基层医生方法==================================================== */
    //切换标签页时触发
    tab2Change(name) {
      this.tab2Name = name;
      this.pageNum1 = 1;
      this.getDoctorList1(1);
      if (name == "tab2_3") {
        this.columns2.splice(7, 0, {
          title: "退回原因",
          key: "ReturnReason",
          align: "center",
          ellipsis: true,
        });
      } else {
        this.columns2 = this.columns2.filter((item) => {
          return item.key != "ReturnReason";
        });
      }
    },
    //审核通过
    pass() {
      Request.postRequest(config.SXG_baseUrl + "/api/currency/UpdateRecord", {
        tablename: "DocList",
        ID: this.doctorRowInfo.row.ID,
        Status: "3",
      }).then((res) => {
        if (res.code == 200) {
          if (this.data2.length == 1 && this.doctor_total1 != 1) {
            this.getDoctorList1(this.pageNum - 1);
          } else {
            this.getDoctorList1(this.pageNum);
          }
          Request.postRequest(config.SXG_baseUrl + '/api/docmanager/PostAddPlatformRole',{
              UserJid:this.doctorRowInfo.row.UserJid,
              RoleID:this.RoleID
            }).then(res1=>{
              if(res1.code != 200){
                this.$Message.error(res1.message)
              }
            })
          this.$Message.success("审核成功");
          this.editModal = false;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    //审核不通过
    noPass() {
      this.returnResult = "";
      this.returnModal = true;
    },
    //审核不通过原因
    returnIsok() {
      if (!this.returnResult) {
        return this.$Message.info("请填写退回原因");
      }
      Request.postRequest(config.SXG_baseUrl + "/api/currency/UpdateRecord", {
        tablename: "DocList",
        ID: this.doctorRowInfo.row.ID,
        Status: "2",
        ReturnReason: this.returnResult,
      }).then((res) => {
        if (res.code == 200) {
          if (this.data1.length == 1 && this.doctor_total != 1) {
            this.getDoctorList1(this.pageNum - 1);
          } else {
            this.getDoctorList1(this.pageNum);
          }
          this.$Message.success("审核成功");
          this.editModal = false;
          this.returnModal = false;
        } else {
          this.$Message.error(res.message);
        }
      });
    },
    /* 点击新建基层医生 */
    addDoctor1() {
      this.editModal = true;
      this.modalTitle = "新增基层医生";
      this.formItem.name = "";
      this.formItem.age = "";
      this.formItem.sex = "";
      this.formItem.phone = "";
      this.formItem.department = "";
      this.formItem.role = "";
      this.formItem.title = "";
      this.formItem.skill = "";
      this.formItem.intro = "";
      this.formItem.hospital = "";
      this.formItem.password = "";
      this.formItem.rePassword = "";
    },
    /* 获取基层医生申请列表 */
    getDoctorList1(page, searchFlag = false) {
      Request.getRequest(config.SXG_baseUrl + "/api/docmanager/GetDocCenter", {
        tablename: "DocList",
        pageSize: this.pageSize,
        pageNum: page,
        searchkey: "DocName",
        searchvalue: searchFlag ? this.doctorName1 : "",
        searchkey1: "CenterID",
        searchvalue1: this.CenterID
      }).then((res) => {
        // console.log(res)
        this.pageNum1 = page;
        res.data.Record.map(item=>{
          if(item.IsJoin == 'T'){
            item.IsJoinText = "已加入"
          }else{
            item.IsJoinText = "未加入"
          }
          
        })
        this.data2 = res.data.Record;
        this.doctor_total1 = parseInt(res.data.count);
      });
    },
    /* 获取基层医生各个状态的数量 */
    getDoctorNum() {
      Request.getRequest(
        config.SXG_baseUrl + "/api/docmanager/GetJiCengDocNum",
        {
          CenterID: this.RoleID == "3" ? '' : this.CenterID,
        }
      ).then((res) => {
        // console.log(res,'医生数量')
        if (res.code == 200) {
          this.doctorNum.pending = res.data[1];
          this.doctorNum.fail = res.data[2];
          this.doctorNum.passed = res.data[3];
        } else {
          this.$Message.info(res.message);
        }
      });
    },

    /* ========================================基层医生方法==================================================== */

    /* ========================================中心医生方法==================================================== */
    /* 获取医生列表 */
    getDoctorList(page, searchFlag = false) {
      Request.getRequest(config.SXG_baseUrl + "/api/currency/GetRecordByPage", {
        tablename: "DocList",
        pageSize: this.pageSize,
        pageNum: page,
        searchkey: "DocName",
        searchvalue: searchFlag ? this.doctorName : "",
        searchkey1: "DocType",
        searchvalue1: "中心",
        searchkey3: "CenterID",
        searchvalue3: this.RoleID == "3" ? '' : this.CenterID,
      }).then((res) => {
        // console.log(res,"获取医生列表")
        this.pageNum = page;
        this.data1 = res.data.Record;
        this.doctor_total = parseInt(res.data.count);
      });
    },

    /* 点击新建医生 */
    addDoctor() {
      this.editModal = true;
      this.modalTitle = "新增中心医生";
      this.formItem.name = "";
      this.formItem.age = "";
      this.formItem.sex = "";
      this.formItem.phone = "";
      this.formItem.department = "";
      this.formItem.role = "";
      this.formItem.title = "";
      this.formItem.skill = "";
      this.formItem.intro = "";
      this.formItem.hospital = "";
      this.formItem.password = "";
      this.formItem.rePassword = "";
      this.hospitalList = [];
      this.formItem.level = "";
    },
    //删除医生-确定按钮
    ok() {
      if (this.modalTitle == "编辑中心医生") {
        Request.postRequest(config.SXG_baseUrl + "/api/currency/DeleteRecord", {
          ID: this.doctorRowInfo.row.ID,
          tablename: "DocList",
          type: "1",
        }).then((res) => {
          if (res.code == 200) {
            if (this.data1.length == 1 && this.doctor_total != 1) {
              this.getDoctorList(this.pageNum - 1);
            } else {
              this.getDoctorList(this.pageNum);
            }
            this.$Message.success("删除成功");
          } else {
            this.$Message.error(res.message);
          }
        });
      } else if (
        this.modalTitle == "审核基层医生" ||
        this.modalTitle == "编辑基层医生" ||
        this.modalTitle == "查看基层医生"
      ) {
        Request.postRequest(config.SXG_baseUrl + "/api/currency/DeleteRecord", {
          ID: this.doctorRowInfo.row.ID,
          tablename: "DocList",
          type: "1",
        }).then((res) => {
          if (res.code == 200) {
            if (this.data1.length == 1 && this.doctor_total != 1) {
              this.getDoctorList1(this.pageNum - 1);
            } else {
              this.getDoctorList1(this.pageNum);
            }
            this.$Message.success("删除成功");
          } else {
            this.$Message.error(res.message);
          }
        });
      }
    },
    //修改或添加医生信息
    updateOrAddDoctorInfo() {
      if (this.modalTitle == "编辑中心医生") {
        if (!this.formItem.name) {
          return this.$Message.info("请填写医生姓名");
        }
        if (!Tools.checkPhone(this.formItem.phone)) {
          return this.$Message.info("请填写正确的手机号码");
        }
        if (!this.formItem.hospital) {
          return this.$Message.info("请选择所属医院");
        }
        if (!this.formItem.department) {
          return this.$Message.info("请选择所属科室");
        }
        if (!this.formItem.role) {
          return this.$Message.info("请选择角色");
        }
        if (!this.formItem.title) {
          return this.$Message.info("请选择职称");
        }
        if (!this.formItem.level) {
          return this.$Message.info("请选择分级");
        }
        let HealthOrgID = "";
        let DepartmentID = "";
        this.hospitalList.map((item) => {
          if (item.OrgName == this.formItem.hospital) {
            HealthOrgID = item.ID;
          }
        });
        this.departmentList.map((item) => {
          if (item.DepartmentName == this.formItem.department) {
            DepartmentID = item.ID;
          }
        });
        let sendData = {
          tablename: "DocList",
          ID: this.formItem.id,
          DocName: this.formItem.name,
          Age: this.formItem.age,
          Sex: this.formItem.sex,
          Introduce: this.formItem.intro,
          Skill: this.formItem.skill,
          DocPosition: this.formItem.title,
          DepartmentID,
          DepartmentName: this.formItem.department,
          HealthOrgID,
          HospitalName: this.formItem.hospital,
          RoleID: this.formItem.role == "中心管理员" ? "2" : "1",
          Role: this.formItem.role,
          Level:this.formItem.level
        };
        this.saveLoading = true;
        Request.postRequest(
          config.SXG_baseUrl + "/api/currency/UpdateRecord",
          sendData
        ).then((res) => {
          if (res.code == 200) {
            this.getDoctorList(this.pageNum);
            this.$Message.success("修改成功");
            this.editModal = false;
            this.saveLoading = false;
          } else {
            this.$Message.error(res.message);
            this.saveLoading = false;
          }
        });
      } else if (this.modalTitle == "新增中心医生") {
        if (!this.formItem.name) {
          return this.$Message.info("请填写医生姓名");
        }
        if (!Tools.checkPhone(this.formItem.phone)) {
          return this.$Message.info("请填写正确的手机号码");
        }
        if (!this.formItem.hospital) {
          return this.$Message.info("请选择所属医院");
        }
        if (!this.formItem.department) {
          return this.$Message.info("请选择所属科室");
        }
        if (!this.formItem.role) {
          return this.$Message.info("请选择角色");
        }
        if (!this.formItem.title) {
          return this.$Message.info("请选择职称");
        }
        if (this.formItem.password.length < 6) {
          return this.$Message.info("密码最少6位");
        }
        if (this.formItem.password != this.formItem.rePassword) {
          return this.$Message.info("两次填写的密码不一致");
        }
        if (!this.formItem.level) {
          return this.$Message.info("请选择分级");
        }
        let HealthOrgID = "";
        let DepartmentID = "";
        this.hospitalList.map((item) => {
          if (item.OrgName == this.formItem.hospital) {
            HealthOrgID = item.ID;
          }
        });
        this.departmentList.map((item) => {
          if (item.DepartmentName == this.formItem.department) {
            DepartmentID = item.ID;
          }
        });
        let sendData = {
          DocName: this.formItem.name,
          Age: this.formItem.age,
          Sex: this.formItem.sex,
          Cellphone: this.formItem.phone,
          UserPws: this.formItem.password,
          Introduce: this.formItem.intro,
          Skill: this.formItem.skill,
          DocPosition: this.formItem.title,
          DocType: "中心",
          DepartmentID,
          DepartmentName: this.formItem.department,
          HealthOrgID,
          DeptID: DepartmentID,
          HospitalName: this.formItem.hospital,
          CenterID: this.CenterID,
          CenterName: this.CenterName,
          RoleID: this.formItem.role == "中心管理员" ? "2" : "1",
          Role: this.formItem.role,
          Level:this.formItem.level
        };
        this.saveLoading = true;
        Request.postRequest(
          config.SXG_baseUrl + "/api/docmanager/RegistMedcareUser",
          sendData
        ).then((res) => {
          if (res.code == 200) {
            this.getDoctorList(1);
            Request.postRequest(config.SXG_baseUrl + '/api/docmanager/PostAddPlatformRole',{
              UserJid:res.data.UserJid,
              RoleID:sendData.RoleID == "1" ? "0" : sendData.RoleID
            }).then(res1=>{
              if(res1.code != 200){
                this.$Message.error(res1.message)
              }
            })
            this.editModal = false;
            this.saveLoading = false;
            if (res.data.IsRegist == true) {
              this.$Modal.info({
                title: "提示",
                content: "<p>您的手机号已经注册过，密码为之前设置的密码！</p>",
              });
            }
          } else {
            this.$Message.error(res.message);
            this.saveLoading = false;
          }
        });
      } else if (this.modalTitle == "新增基层医生") {
        if (!this.formItem.name) {
          return this.$Message.info("请填写医生姓名");
        }
        if (!Tools.checkPhone(this.formItem.phone)) {
          return this.$Message.info("请填写正确的手机号码");
        }
        if (!this.formItem.hospital) {
          return this.$Message.info("请选择所属医院");
        }
        if (!this.formItem.department) {
          return this.$Message.info("请选择所属科室");
        }
        if (!this.formItem.role) {
          return this.$Message.info("请选择角色");
        }
        if (!this.formItem.title) {
          return this.$Message.info("请选择职称");
        }
        if (this.formItem.password.length < 6) {
          return this.$Message.info("密码最少6位");
        }
        if (this.formItem.password != this.formItem.rePassword) {
          return this.$Message.info("两次填写的密码不一致");
        }
        let HealthOrgID = "";
        let DepartmentID = "";
        this.hospitalList.map((item) => {
          if (item.OrgName == this.formItem.hospital) {
            HealthOrgID = item.ID;
          }
        });
        this.departmentList.map((item) => {
          if (item.DepartmentName == this.formItem.department) {
            DepartmentID = item.ID;
          }
        });
        let sendData = {
          DocName: this.formItem.name,
          Age: this.formItem.age,
          Sex: this.formItem.sex,
          Cellphone: this.formItem.phone,
          UserPws: this.formItem.password,
          Introduce: this.formItem.intro,
          Skill: this.formItem.skill,
          DocPosition: this.formItem.title,
          DocType: "基层",
          DepartmentID,
          DepartmentName: this.formItem.department,
          HealthOrgID,
          DeptID: DepartmentID,
          HospitalName: this.formItem.hospital,
          CenterID: this.CenterID,
          CenterName: this.CenterName,
          RoleID: this.formItem.role == "中心管理员" ? "2" : "1",
          Role: this.formItem.role,
          Status: 3,
        };
        this.saveLoading = true;
        Request.postRequest(
          config.SXG_baseUrl + "/api/docmanager/RegistMedcareUser",
          sendData
        ).then((res) => {
          if (res.code == 200) {
            this.tab2Name = "tab2_2";
            this.getDoctorList1(1);
            Request.postRequest(config.SXG_baseUrl + '/api/docmanager/PostAddPlatformRole',{
              UserJid:res.data.UserJid,
              RoleID:sendData.RoleID
            }).then(res1=>{
              if(res1.code != 200){
                this.$Message.error(res1.message)
              }
            })
            this.editModal = false;
            this.saveLoading = false;
            if (res.data.IsRegist == true) {
              this.$Modal.info({
                title: "提示",
                content: "<p>您的手机号已经注册过，密码为之前设置的密码！</p>",
              });
            }
          } else {
            this.$Message.error(res.message);
            this.saveLoading = false;
          }
        });
      } else if (this.modalTitle == "编辑基层医生") {
        if (!this.formItem.name) {
          return this.$Message.info("请填写医生姓名");
        }
        if (!Tools.checkPhone(this.formItem.phone)) {
          return this.$Message.info("请填写正确的手机号码");
        }
        if (!this.formItem.hospital) {
          return this.$Message.info("请选择所属医院");
        }
        if (!this.formItem.department) {
          return this.$Message.info("请选择所属科室");
        }
        if (!this.formItem.role) {
          return this.$Message.info("请选择角色");
        }
        if (!this.formItem.title) {
          return this.$Message.info("请选择职称");
        }
        let HealthOrgID = "";
        let DepartmentID = "";
        this.hospitalList.map((item) => {
          if (item.OrgName == this.formItem.hospital) {
            HealthOrgID = item.ID;
          }
        });
        this.departmentList.map((item) => {
          if (item.DepartmentName == this.formItem.department) {
            DepartmentID = item.ID;
          }
        });
        let sendData = {
          tablename: "DocList",
          ID: this.formItem.id,
          DocName: this.formItem.name,
          Age: this.formItem.age,
          Sex: this.formItem.sex,
          Introduce: this.formItem.intro,
          Skill: this.formItem.skill,
          DocPosition: this.formItem.title,
          DepartmentID,
          DepartmentName: this.formItem.department,
          HealthOrgID,
          HospitalName: this.formItem.hospital,
          RoleID: this.formItem.role == "中心管理员" ? "2" : "1",
          Role: this.formItem.role,
        };
        this.saveLoading = true;
        Request.postRequest(
          config.SXG_baseUrl + "/api/currency/UpdateRecord",
          sendData
        ).then((res) => {
          if (res.code == 200) {
            this.getDoctorList1(this.pageNum);
            this.$Message.success("修改成功");
            this.editModal = false;
            this.saveLoading = false;
          } else {
            this.$Message.error(res.message);
            this.saveLoading = false;
          }
        });
      }
    },

    /* ========================================中心医生方法==================================================== */
  },
};
</script>

<style lang="less">
.doctor_management {
  .v-transfer-dom {
    .ivu-modal-header {
      border: none;
    }

    .ivu-modal-body {
      display: none;
    }

    .ivu-modal-footer {
      border: none;
    }
  }

  margin: 20px 30px;

  .opration {
    display: flex;
    justify-content: space-between;
    margin: 0 0 15px;
    .invite {
      margin-right: 15px;
    }
  }

  .pagination {
    position: fixed;
    bottom: 30px;
    right: 100px;
  }
}

.modal1,
.modal2,
.modal3 {
  .color_red {
    color: red;
  }

  .title {
    font-weight: 700;
    font-size: 15px;
    color: #000;
    padding-left: 5px;
    border-left: 5px solid #0073d3;
  }

  .content {
    margin-top: 20px;
  }

  .label_title {
    margin-bottom: 5px;
  }

  .mod {
    width: 80%;
    margin: 0 auto;
    margin-bottom: 20px;
  }

  .btn_box {
    margin: 30px 0;
    text-align: center;
    .basic_btn {
      button:first-child {
        margin-right: 30px;
      }
    }
  }

  .role_box {
    margin-top: 5px;

    .role_title {
      height: 35px;
      line-height: 35px;
      background: #1890ff;
      color: #fff;
      font-weight: 700;
      padding-left: 15px;
      font-size: 15px;

      span:first-child {
        margin-right: 120px;
      }
    }

    .role_content {
      .row {
        border-bottom: 1px solid #eee;
        padding: 8px 0 5px 15px;

        .mar {
          margin-right: 97px;
        }
      }
    }
  }
}
.tab1 {
  .ivu-divider-horizontal {
    height: 2px;
    margin-top: 5px;
  }
  & > .ivu-tabs-bar {
    border-bottom: none;
    .ivu-tabs-nav {
      .ivu-tabs-tab {
        background: #fff;
        margin-right: 0;
        border-bottom: 1px solid #dcdee2;
        color: #999999;
        font-weight: 700;
        height: 31px;
        &:nth-of-type(2) {
          border-radius: 4px 0 0 4px;
        }
        &:nth-of-type(3) {
          border-left: 0;
          border-radius: 0 4px 4px 0;
        }
      }
      .ivu-tabs-tab-active {
        background: #1890ff;
        color: #fff;
        height: 31px;
      }
    }
  }
}
.tab2 {
  & > .ivu-tabs-bar {
    .ivu-tabs-nav {
      width: 100%;
      .ivu-tabs-tab {
        width: 33.3%;
        text-align: center;
        margin-right: 0;
        border-top: 3px solid #fff;
        border-left: 0;
        border-right: 0;
        background: #fff;
        border-radius: 4px 4px 0 0;
      }
      .ivu-tabs-tab-active {
        border-top: 3px solid #1890ff;
        border-left: 1px solid #dcdee2;
        border-right: 1px solid #dcdee2;
        color: #515a6e;
      }
    }
  }
}
.return_modal {
  .ivu-modal {
    top: 200px;
  }
  .title {
    font-weight: 700;
    font-size: 15px;
    color: #000;
    padding-left: 5px;
    border-left: 5px solid #0073d3;
  }
  .content {
    margin: 15px 0;
  }
  .btn_box {
    text-align: center;
    button:first-child {
      margin-right: 20px;
    }
  }
}
</style>